import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
    quizzesArray: []
}

export const fetchQuizzes = createAsyncThunk(
    'quizzes/fetchQuizzes',
    async (accessToken, thunkAPI) => {
        try {
            const quizzesPromise = await fetch(process.env.REACT_APP_DATABASE_URL + '/quizzes', {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                mode: 'cors',
                credentials: 'include'
            });
            const quizzes = await quizzesPromise.json();
            return quizzes;
        } catch (err) {
            return thunkAPI.rejectWithValue(err.message);
        }
    }
);

export const quizzesSlice = createSlice({
    name: 'quizzes',
    initialState,
    reducers: {
        quizDeleted: (state, action) => {
            const temp_array = state.quizzesArray.filter(quiz => quiz.id !== parseInt(action.payload));
            state.quizzesArray = temp_array;
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(fetchQuizzes.pending, (state, action) => {
        })
        .addCase(fetchQuizzes.fulfilled, (state, action) => {
            const quizzesData = action.payload;

            if (quizzesData.success === true) {
                state.quizzesArray = quizzesData.list_quizzes;
            } else {
                alert(`Issue fetching quizzes. Error: ${quizzesData.code}. Description: ${quizzesData.description}.`);
            }
        })
        .addCase(fetchQuizzes.rejected, (state, action) => {
        })
    }
});

export const { quizDeleted } = quizzesSlice.actions;
export default quizzesSlice.reducer;
